import { render } from "./SendMessage.vue?vue&type=template&id=104ac748&ts=true"
import script from "./SendMessage.vue?vue&type=script&lang=ts"
export * from "./SendMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__